import { render, staticRenderFns } from "./ProfissionalSetting.vue?vue&type=template&id=5fe2606e"
import script from "./ProfissionalSetting.vue?vue&type=script&lang=js"
export * from "./ProfissionalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports